import styled, { keyframes } from "styled-components";

export const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const RadioChannel = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 76px;
  padding: 0 42px 0 36px;
  height: 100%;
  min-height: 72px;
  width: 100%;
  border-radius: 24px;
  cursor: pointer;
  outline: ${({ isActive }) =>
    isActive ? "3px solid var(--orange-primary)" : "none"};
  overflow: hidden;
  animation: ${fade} ${(props) => props.duration + "ms"} forwards;

  @media (max-width: 524px) {
    padding: 0 18px 0 16px;

    gap: 0px;
  }

  div {
    align-self: flex-end;
    display: flex;
    position: relative;
    svg {
      overflow: visible;
      position: absolute;
    }
  }

  &:nth-child(1) {
    background-color: #313131;

    @media (max-width: 652px) {
      > svg {
        width: 109px;
      }
    }

    div {
      svg {
        right: -40px;
      }
    }

    @media (max-width: 524px) {
      > svg {
        width: 82px;
      }
      img {
        width: 98px;
      }

      div {
        svg {
          top: -30px;
          right: -21px;
          width: 130px;
        }
      }
    }
  }
  &:nth-child(2) {
    background: linear-gradient(90deg, #a83222 0%, #71271d 100%);

    @media (max-width: 652px) {
      > svg {
        width: 180px;
      }
    }

    div {
      svg {
        right: -35px;
      }
    }

    @media (max-width: 524px) {
      > svg {
        width: 153px;
      }
      img {
        width: 80px;
      }

      div {
        svg {
          top: -30px;
          right: -18px;
          width: 135px;
        }
      }
    }
  }
  &:nth-child(3) {
    background: linear-gradient(90deg, #615fff 0%, #372864 100%);

    @media (max-width: 652px) {
      > svg {
        width: 83px;
      }
    }

    div {
      svg {
        right: -35px;
      }
    }

    @media (max-width: 524px) {
      > svg {
        width: 56px;
      }
      img {
        width: 92px;
      }
      div {
        svg {
          top: -30px;
          right: -10px;
          width: 135px;
        }
      }
    }
  }
`;
